import { useTranslation } from "react-i18next";
import { TypographyComponent } from "@gx1/gx-npm-ui";
import styles from "./no-evaluations.styles.module.scss";
import imgNoActiveEvaluations from "./no-evaluations.svg";

const NoEvaluations = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.text}>
        <TypographyComponent color="coal" boldness="semi" styling="p4" rootClassName={styles.title}>
          {t("No active evaluations")}
        </TypographyComponent>
        <TypographyComponent color="iron" styling="p4">
          {t("Your most recent evaluation activity will appear here")}
        </TypographyComponent>
      </div>
      <img alt={t("No active evaluations")} className={styles.imgEmpty} src={imgNoActiveEvaluations} />
    </div>
  );
};

export default NoEvaluations;
